import {
  Chart as ChartJS,
  ArcElement,
  BarController,
  BarElement,
  PieController,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  ArcElement,
  BarController,
  BarElement,
  PieController,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
)

export default ChartJS
